























import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import moment from "moment";
import '@/styles/iucn/filter.css';
import '@/styles/iucn/main-content.css';
import ApplicationCardComponent from '@/components/common/Cards/ApplicationCard.vue';
import { AppConstants as _app } from '@/shared/app.constants';
import { ICallFilter } from "@/entities";

@Component({
    components: {
        ApplicationCardComponent
    }
})
export default class ProposalCallsComponent extends Vue {
    @Action("createApplication", { namespace: "application" })
    createApplication: any;
    @Action("setCallId", { namespace: "application" }) setCall: any
    @Action("setCallId", { namespace: "conceptNote" }) setCallId: any;
    @Action("resetAppState", { namespace: "application" }) resetAppState: any

    calls: Array<any> = [];
    countLoop: number = 0;
    dataLength: number = 0;
    dialog: boolean = true;
    InitiativeCallId: any = null;
    callTypes: any = _app.InitiativeCallType;
    filterItems: Array<any> = _app.InitiativeCallType;
    selectedCallType = 0;

    /** mount fn */
    mounted() {
        var self = this;
        /** reset the application state on page load */
        this.resetAppState();
        this.getCallLists();
    }

    /** Create new application while register */
    showDeclaration(callId: number, programid: number, typeId: number) {
        var self = this;
        /** update the state */
        this.setCall(callId);
        this.setCallId(callId);

        var pid = programid.toString();
        var tigerProgramId = _app.programs.tiger;
        var DeclarationContentkey = 'ApplicantDeclarationContent';
        var title = this.callTypes.find(t => t.TypeId === typeId)?.title

        this.$router.push({
            name: this.callTypes.find(t => t.TypeId === typeId)?.RouteName,
            params: {
                programid: pid,
                DeclarationContentkey: DeclarationContentkey,
                title: title
            }
        });
    }

    getCallLists() {
        var self = this;
        const filter: ICallFilter = {
            CallTypeId: this.selectedCallType
        };
        this.$services.dashboard.getInitiativeCallList(filter).then((resp: any) => {
            self.dataLength = resp.length - 1;
            if (resp.length > 0) {
                self.calls = resp[0].data.Items;                
                for (
                    self.countLoop = 1;
                    self.countLoop <= self.dataLength;
                    self.countLoop++
                ) {
                    self.calls.push = resp[self.countLoop].data.Items;
                }
            }
        });
    }

    get filterMenu() {
        var item = { Text: "All", TypeId: 0, RouteName: "" };
        this.filterItems.unshift(item);
        this.filterItems.map(x => {
            x.Text = this.$t(x.Text);
        });
        return this.filterItems;
    }
}
